import { AuthenticationService } from './authentication.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable} from '@angular/core';
import { Observable } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../environments/environment';
import { BlobFile } from '../models/blobFile';


@Injectable()
export class FileService {

    constructor(private http: HttpClient, private authService : AuthenticationService, private domSanitizer: DomSanitizer) {}

    private getHeaderWithToken() : HttpHeaders {
        return new HttpHeaders({
            'authorization': 'Bearer ' + this.authService.getToken(),
            'reportProgress' : 'true',
            'observe' : 'events'
          });
    }

    getAll() : Observable<BlobFile[]> {
        return this.http.get<BlobFile[]>(environment.serverUrl + 'api/blob/file/list/', { headers: this.getHeaderWithToken() });
    }

    async getSecure2(src : string) : Promise<any> {
        const token = this.authService.getToken();
        const headers = new HttpHeaders({'Authorization': `Bearer ${token}`});
        const imageBlob = await this.http.get(src, {headers, responseType: 'blob'}).subscribe((data) => {

            let blob = new Blob([data], {type: 'application/pdf'});
          
            let downloadURL = window.URL.createObjectURL(data);
            let link = document.createElement('a');
            link.href = downloadURL;
            link.download = "help.pdf";
            link.click();
          
          });
    }

    async getSecure(src : string) : Promise<any> {
        console.log(src);
        const token = this.authService.getToken();
        const headers = new HttpHeaders({'Authorization': `Bearer ${token}`});
        const imageBlob = await this.http.get(src, {headers, responseType: 'blob'}).toPromise();
        const reader = new FileReader();

        return new Promise(resolve => {
            reader.onloadend = () => resolve(reader.result as string);
            if(imageBlob) reader.readAsDataURL(imageBlob);
        });
    }

    upload(files: File[]) : Observable<BlobFile> {
        var formData = new FormData();
        Array.from(files).forEach(f => formData.append('file',f))

        return this.http.post<BlobFile>(environment.serverUrl + 'api/blob/file', formData, { headers: this.getHeaderWithToken() });
    }

    delete(file : BlobFile) : Observable<{}> {
        return this.http.delete(environment.serverUrl + 'api/blob/file/' + file.id, { headers: this.getHeaderWithToken() });
    }
}
